import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { RouterOutlet } from '@angular/router';
import { Component, inject, signal } from '@angular/core';
import { Spinner } from './shared/components/spinner/spinner';
import { NetworkStatusBanner } from './shared/components/network-status-banner/network-status-banner';
import { SpinnerService } from './shared/components/spinner/services/spinner-service';
import { Main } from '@shared/layouts/main/main';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { DividerModule } from 'primeng/divider';
@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    CardModule,
    ButtonModule,
    NetworkStatusBanner,
    Spinner,
    Main,
    ToastModule,
    ConfirmDialog,
    DividerModule,
  ],
  providers: [
    ConfirmationService,
  ],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  public readonly spinnerService = inject(SpinnerService);
  protected readonly title = signal('wms');
}
